<template>
  <div id="projects">

    <div class="container">

      <div class="row">

        <div class="col-md-12">
          <div class="title">
            Organizações <span>Sociais</span>
          </div>
          <router-link class="all" to="/projects">ver todos</router-link>
        </div>

        <div class="col-md-12">
          <ul class="filter d-none">
            <li class="active"><a href="">Recomendadas</a></li>
            <li><a href="">Novas</a></li>
            <li><a href="">Mais Visitadas</a></li>
          </ul>
        </div>
      </div>

    </div>

    <div class="container-fluid">

      <div class="row list" v-if="featuredProjects && featuredProjects.length > 0">
          <div class="col-md-4 big">
            <div class="project" v-if="featuredProjects[0].Info">
              <img :src="featuredProjects[0].Info.image" />
              <div class="info">
                <div class="content">
                  <span class="title">{{featuredProjects[0].Info.title}}</span>
                  <p class="description">{{featuredProjects[0].Info.shortDescription}}</p>
                  <router-link :to="'/project/' + featuredProjects[0].slug" href="">Saiba mais</router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 small">
            <div class="project" v-if="featuredProjects[1].Info">
              <img :src="featuredProjects[1].Info.image" />
              <div class="info">
                <div class="content">
                  <span class="title">{{featuredProjects[1].Info.title}}</span>
                  <p class="description">{{featuredProjects[1].Info.shortDescription}}</p>
                  <router-link :to="'/project/' + featuredProjects[1].slug" href="">Saiba mais</router-link>
                </div>
              </div>
            </div>
            <div class="project" v-if="featuredProjects[2].Info">
              <img :src="featuredProjects[2].Info.image" />
              <div class="info">
                <div class="content">
                  <span class="title">{{featuredProjects[2].Info.title}}</span>
                  <p class="description">{{featuredProjects[2].Info.shortDescription}}</p>
                  <router-link :to="'/project/' + featuredProjects[2].slug" href="">Saiba mais</router-link>
                </div>
              </div>
            </div>
            <div class="project" v-if="featuredProjects[3].Info">
              <img :src="featuredProjects[3].Info.image" />
              <div class="info">
                <div class="content">
                  <span class="title">{{featuredProjects[3].Info.title}}</span>
                  <p class="description">{{featuredProjects[3].Info.shortDescription}}</p>
                  <router-link :to="'/project/' + featuredProjects[3].slug" href="">Saiba mais</router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4 medium">
            <div class="project" v-if="featuredProjects[4].Info">
              <img :src="featuredProjects[4].Info.image" />
              <div class="info">
                <div class="content">
                  <span class="title">{{featuredProjects[4].Info.title}}</span>
                  <p class="description">{{featuredProjects[4].Info.shortDescription}}</p>
                  <router-link :to="'/project/' + featuredProjects[4].slug" href="">Saiba mais</router-link>
                </div>
              </div>
            </div>
            <div class="project" v-if="featuredProjects[5].Info">
              <img :src="featuredProjects[5].Info.image" />
              <div class="info">
                <div class="content">
                  <span class="title">{{featuredProjects[5].Info.title}}</span>
                  <p class="description">{{featuredProjects[5].Info.shortDescription}}</p>
                  <router-link :to="'/project/' + featuredProjects[5].slug" href="">Saiba mais</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="loading-projects">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                  <span>
                    <font-awesome-icon class="fa-spin" :icon="['fas', 'spinner']"/><br>Carregando ONGs...
                  </span>
              </div>
            </div>
          </div>
        </div>

    </div>

  </div>
</template>

<script>
import Functions from '../../utils/functions'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {fasSpinner} from '@fortawesome/fontawesome-free-solid'

export default {
  props: ['projects'],
  data(){
    return {
      featuredProjects: null
    }
  },
  components: {
    FontAwesomeIcon,
  },
  mounted(){
    if(this.projects){
      this.featuredProjects = this.projects.filter((e) => {
        return (e.isFeatured);
      });
      this.featuredProjects = Functions.arrayShuffle(this.featuredProjects)
      this.featuredProjects.splice(6, this.featuredProjects.length - 6);
    }
  },
  methods: {
    filterRecomendados(){

    },
    filterNovos(){

    },
    filterMaisClicados(){

    },
    renderList(list){
      this.$forceUpdate();
    }
  },
  watch: {
    projects: {
      handler(newList, oldList) {
        this.featuredProjects = newList.filter((e) => {
          return (e.isFeatured);
        });
        this.featuredProjects = Functions.arrayShuffle(this.featuredProjects)
        this.featuredProjects.splice(6, this.featuredProjects.length - 6);
      },
      deep: true
    },
  }
}
</script>

<style scoped lang="scss">
#projects{
  background-color: #fff;
  min-height: 600px;
  padding-bottom: 40px;

  .title{
    margin-top: 40px;
    font-size: 28px;
    font-family: RalewayRegular;
    @media screen and (max-width: 380px){
      font-size: 25px;
    }

    span{
      color: #00AE39;
    }
  }

  .filter{
    list-style: none;
    padding: 0;
    margin-top: 20px;

    li{
      display: inline;
      padding: 10px;
      margin-right: 40px;

      a{
        font-size: 18px;
        font-family: RalewayBold;
        color: #392f2f;
        text-decoration: none;
      }

      &.active{
        border-bottom: 3px solid #00AE39;
        a{
          color: #00AE39;
        }
      }
    }
  }

  .all{
    position: absolute;
    right: 30px;
    top: 50px;
    color: #00AE39;
    text-decoration: none;
    font-family: RalewayBold;
  }

  .container-fluid{
    padding-right: 0px;
    padding-left: 30px;
  }

  .loading-projects{
    span{
      width: 100%;
      display: block;
      text-align: center;
      padding: 20px;
      font-size: 30px;
      color: #00AE39;
    }
  }

  .list{
    width: 100%;

    .project{
      width: 100%;
      min-height: 200px;
      position: relative;
      overflow: hidden;
      padding-top: 5px;
      padding-bottom: 5px;
      margin-top: 10px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      img{
        display: block;
        position: absolute;
        resize: contain;
        min-height: 100%;
        z-index: 9;
      }

      .info{
        position: absolute;
        display: none;
        z-index: 10;
        background-color: #000;
        width: 100%;
        min-height: 200px;
        opacity: 0.8;

        .content{
          display: block;
          position: absolute;
          padding: 20px;
          width: 100%;
        }

        .title{
          font-family: RalewayBold;
          font-size: 22px;
          color: #fff;
        }

        .description{
          font-family: RalewayRegular;
          color: #fff;
        }

        a{
          display: block;
          background-color: #00AE39;
          color: #fff;
          border-radius: 5px;
          padding: 7px;
          text-decoration: none;
          cursor: pointer;
          text-align: center;
        }
      }

      &:hover{
        .info{
          display: block;
        }
      }
    }

    .small{
      padding-left: 5px;
      padding-right: 5px;
      .project{
        height: 200px;
        .info{
          height: 200px;
        }
      }
      @media screen and(max-width: 767px){
        .project{
          height: 305px;
          .info{
            height: 305px;
            display: block;
            .content{
              bottom: 0px;
            }
          }
        }
      }
    }

    .medium{
      padding-left: 5px;
      padding-right: 5px;
      .project{
        height: 305px;
        .info{
          height: 305px;
        }

        @media screen and(max-width: 767px){
        .info{
          display: block;
          .content{
            bottom: 0px;
          }
        }
      }
      }
    }

    .big{
      padding-left: 5px;
      padding-right: 5px;
      .project{
        height: 620px;
        .info{
          height: 620px;
        }
      }
      @media screen and(max-width: 767px){
        .project{
          height: 305px;
          .info{
            height: 305px;
            display: block;
            .content{
              bottom: 0px;
            }
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/ProjectsSection.vue